module.exports = __webpack_public_path__ + "images/09-03@2x_0a5c0ea3.png";